<template>
  <v-dialog v-model="show" persistent max-width="600px">
    <v-card>
      <v-toolbar color="pink lighten-2" dark>
        <v-toolbar-title class="headline"
          >Ladda upp åtgärdsprogram</v-toolbar-title
        >
      </v-toolbar>

      <v-card-text>
        <v-container>
          <v-flex>
            <v-flex>
              <v-text-field
                label="Namn"
                hint="Elevens namn"
                required
                v-model="NewAP.name"
              ></v-text-field>
            </v-flex>
             <v-flex>
              <v-select
                v-model="NewAP.class"
                :items="classesnameandId"
                required
                item-text="[0]"
                item-value="[1]"
                attach
                chips
                label="Klass"
                hint="Vilken klass går berörd elev i."
              ></v-select>
            </v-flex>
            <v-flex>
                <v-select
          :items="[1,2,3,4,5,6]"
          
          v-model="Links"
          label="Antal länkade dokument?"
          outlined
        ></v-select>
              <div v-for="(länk,index) in Links" :key="länk">
                          <!-- <span class="headline">Länk {{index+1}}</span> -->
                     <span class="headline">Länk {{NewAP.link[index].title==""?index+1:NewAP.link[index].title}}</span> 
                              <v-text-field
                label="Titel"
                hint="Förklarande rubrik för länken"
                v-model="NewAP.link[index].title"
              ></v-text-field>
              <v-text-field
                label="Länk"
                hint="Länk till åtgärdsprogrammet/Utredning eller annat dokument"
                v-model="NewAP.link[index].link"
              ></v-text-field>
              </div>
            </v-flex>
            <v-flex>
      <v-radio-group v-model="NewAP.accessType">
                <template v-slot:label>
                  Vilka ska ha åtkomst till åtgärdsprogrammet?
                  <v-btn icon @click="info = !info">
                    <v-icon
                      :color="info ? 'indigo darken-1' : 'blue-grey lighten-4'"
                      >info</v-icon
                    >
                  </v-btn>
                </template>
                <div v-if="info == true">
                <span id="infohead" class="subtitle-1"> Info:</span>
                <p  id="info" >
                <span class="body-2">  Alla betyder klassens mentor, lärare samt annan personal som
                  valts till i viss personal. Viss personal väljer man om
                  man inte tänker att klassens alla lärare eller mentor ska ha
                  åtkomst till dokumentet.</span>
                </p>
                </div>
                <v-radio label="Elevens mentor" value="mentor"></v-radio>
                <v-radio
                  label="Elevens lärare inklusive mentor."
                  value="teacher"
                ></v-radio>
                <v-radio label="Viss personal" value="spec"></v-radio>
                <v-radio label="Alla" value="all"></v-radio>
              </v-radio-group>
            </v-flex>
           

            <v-flex
              v-if="NewAP.accessType == 'spec' || NewAP.accessType == 'all'"
            >
              <v-select
                v-model="NewAP.specAccess"
                :items="teachernameandId"
                item-text="[0]"
                item-value="[1]"
                attach
                chips
                label="Lärare"
                hint="Vilken lärare ska ha åtkomst?"
                multiple
              ></v-select>
            </v-flex>
            <v-flex justify="center">
              <h3>När är dokumentet är skapat</h3>
              <v-date-picker
                color="pink lighten-2"
                v-model="NewAP.createDate"
              ></v-date-picker>
            </v-flex>
            <v-flex justify="center">
              <h3>När börjar åtgärdsprogrammet?</h3>
              <v-date-picker
                color="pink lighten-2"
                v-model="NewAP.startDate"
              ></v-date-picker>
              <h3>När är åtgärdsprogrammet slut?</h3>
              <v-date-picker
                color="pink lighten-2"
                v-model="NewAP.endDate"
              ></v-date-picker>
            </v-flex>

            <v-flex>
              <v-radio-group
                label="Är länken tidsbestämd? För ökad säkerhet rekommenderas alltid tidsbestämda länkar samt att endast de inom organisationen ska ha åtkomst."
                v-model="Specialaccess"
              >
                <v-radio label="Ja" value="ja"></v-radio>
                <v-radio label="Nej" value="nej"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex v-if="Specialaccess == 'ja'">
              <p>När går den tidsbestämda länken ut?</p>
              <v-date-picker
                color="pink lighten-2"
                v-model="NewAP.expireDate"
              ></v-date-picker>
            </v-flex>
          </v-flex>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn dark color="red darken-1" @click="Close()"> Stäng </v-btn>
        <v-btn
          color="green lighten-1"
          text
          dark
          @click="change()"
          v-if="Oldclass != null"
        >
          Uppdatera åtgärdsprogram
        </v-btn>
        <v-btn color="green lighten-1" text dark @click="change()" v-else>
          Skapa åtgärdsprogram
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "NewAP",

  watch: {
  Links: function() {
    if (this.NewAP.link.length > this.Links) {
     for (let i = this.NewAP.link.length; i > this.Links; i--) {
     this.NewAP.link.pop() 
     }
    }
for (let i = this.NewAP.link.length; i < this.Links; i++) {
this.NewAP.link.push({title:"", link:""})
}
  }
  },
  computed: {
    show: {
      get() {
        if (this.Oldclass != null) {
          this.NewAP =   JSON.parse(JSON.stringify(this.Oldclass));  
          this.Links= this.NewAP.link.length;

          this.update = true;
        }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  created() {
    if (this.Oldclass != null) {
      this.NewAP = this.Oldclass;
    }
  },
  props: {
    teachernameandId: Array,
    classesnameandId: Array,
    Oldclass: Object,
    schoolId: String,
    id: String,
    value: Boolean,
  },
  data() {
    return {
      update: false,
      Specialaccess: "nej",
      info: false,
      Links: 1,
      NewAP: {
        schoolId: this.schoolId,
        link:[{title:"", link:""}]
      },
      locfun: null,
    };
  },

  methods: {
    ...mapActions("classesAP", ["createAP", "saveAP"]),

    ...mapActions(["showSuccessSnackbar", "showTipSnackbar"]),

Close(){
  
if (this.update) {
  
        
          this.NewAP =   JSON.parse(JSON.stringify(this.Oldclass));
 
 }

  this.show = false
},

    change() {
      if (typeof this.NewAP.createDate == "object") {
        this.NewAP.createDate = this.NewAP.createDate.getTime();
      }
      if (typeof this.NewAP.startDate == "object") {
        this.NewAP.startDate = this.NewAP.startDate.getTime();
      }
      if (typeof this.NewAP.endDate == "object") {
        this.NewAP.endDate = this.NewAP.endDate.getTime();
      }
      if (this.NewAP.hasOwnProperty("expireDate"))
        if (typeof this.NewAP.expireDate == "object") {
          this.NewAP.expireDate = this.NewAP.expireDate.getTime();
        }
      // if (this.NewAP.accessType.length!=1) {
      //   if (this.NewAP.accessType.length==3) {
      //     this.NewAP.accessType=="all";
      //   }
      //   else if
      // }

      if (this.update == false) {
        this.NewAP.type = "Åtgärdsprogram";
        this.NewAP.uploader = this.id;
        this.NewAP.schoolId = this.schoolId;
        //  (this.NewAP)
        this.createAP(this.NewAP);
        this.showSuccessSnackbar(
          "Åtgärdsprogram för " + this.NewAP.name + " är skapad!"
        );
      } else {
        //  (this.NewAP)

        this.saveAP(this.NewAP);
        this.showSuccessSnackbar(
          "Åtgärdsprogram för " + this.NewAP.name + " är updaterad!"
        );
      }
      if (this.Oldclass == null) {
        this.NewAP = {
          schoolId: this.schoolId,
        link:[{title:"", link:""}]
        };
      }
      this.show = false;
    },
  },
};
</script>
<style >
#info {
  border: #3949ab 2px solid;
  border-radius: 15px;
  color: #bdbdbd;
  padding: 5px;
}
#infohead {
  color: #bdbdbdbb;
  padding-left: 5px;
}
</style>